

























































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { forOwn } from 'lodash'
import { Meta } from '@/helpers/decorators'

// Mixins
import TableMixin from '@/mixins/Table'
import MissionMixin from '@/mixins/Mission'
import DateMixin from '@/mixins/Date'
import ErrorsMixin from '@/mixins/Errors'
import Filters from '@/mixins/Filter'

// Api
import { mapData, MISSION_API_MAPPING, MISSION_ROW_API_MAPPING, REPORT_ROW_API_MAPPING } from '@/api/Mapping'

// Models
import Mission from '@/models/Mission'
import ReportRow from '@/models/ReportRow'

// enums
import { ReportStateType } from '@/enums/ReportStateType'

// Components
import MissionReportStateTag from '@/views/missions/MissionReportStateTag.vue'
import Box from '@/components/common/Box.vue'
import DateRanger from '@/components/common/DateRanger.vue'
// import InfoBox from '@/components/common/InfoBox.vue'

// Views
import AssignReportForm from '@/views/all/forms/AssignReportForm.vue'

@Component({
  components: { MissionReportStateTag, Box, AssignReportForm, DateRanger }
})
export default class ListAllMissions extends Mixins(TableMixin, DateMixin, MissionMixin, ErrorsMixin, Filters) {
  showAssignReportModal: boolean = false
  assignDatas = null

  // Pagination
  offset = 0
  limit = 20
  end = false

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale

  @Meta
  metas() {
    return {
      title: this.$t('menu.missions'),
      titleTemplate: `${this.$t('missions.tab.list')} - %s - ${process.env.VUE_APP_NAME}`
    }
  }

  @Watch('$route', { immediate: true })
  async fetchMissionsWithParams(route) {
    this.offset = 0
    this.search = route.query.search ? route.query.search : null
    this.startDate = route.query.range ? route.query.range.split(',')[0] : null
    this.endDate = route.query.range ? route.query.range.split(',')[1] : null
    await this.fetch(false)
  }

  @Watch('locale')
  async updateDataWithCurrentLocale() {
    this.offset = 0
    await this.fetch(false)
  }

  get params(): {} {
    const params = {
      limit: this.limit,
      offset: this.offset
    }

    forOwn(this.$route.query, (value, key) => {
      params[key] = value
    })

    return params
  }

  goToReport(mission) {
    this.$router.push({ name: 'singleReport', params: { id: mission.report.proovCode } })
  }

  parseMission(mission) {
    const model = new Mission(mapData(MISSION_ROW_API_MAPPING, mission, false, true))
    model.parseReceiver(mission)

    if (!mission._report) {
      return model
    }

    const report = new ReportRow(mapData(REPORT_ROW_API_MAPPING, mission._report, false, true))
    report.parseRow(mission._report , this.locale)
    model.report = report

    return model
  }

  async fetch(add: boolean) {
    try {
      this.tableLoading = true
      const res = await this.$api.missions.fetchMissions(this.token, this.params)
      if (!Array.isArray(res.data)) {
        return
      }
      const missions = res.data.map((item) => this.parseMission(item))
      this.data = add ? [...this.data, ...missions] : missions
      this.end = missions.length === 0
      this.offset += this.limit
    } finally {
      this.tableLoading = false
    }
  }

  async loadMore() {
    await this.fetch(true)
  }

  async mounted() {
    const res = await this.$api.missions.fetchMissions(this.token, this.params)
    this.firstLoad = false
    this.hasData = res.data.length > 0
  }

  // Helpers
  canAssignReturnMission(mission) {
    return mission.report.state === 'pending_second' && mission.reportState === 'pending_first'
  }

  missionIsPending(mission) {
    return 'FINISH' !== mission.state
  }

  // Controls
  editMission(mission) {
    this.assignDatas = { ...mission, edit: true }
    this.showAssignReportModal = true
  }

  assignMission(mission) {
    this.assignDatas = { ...mission, edit: false }
    this.showAssignReportModal = true
  }

  sendReturnMission(mission) {
    this.assignDatas = {
      ...mission, edit: false, reportState: 'pending_second', startDate: new Date().toString()
    }
    this.showAssignReportModal = true
  }

  async updateMission(formData) {
    const data = {...formData, proovCode: this.assignDatas.report.proovCode, reportState: this.assignDatas.reportState }

    try {
      const res = this.assignDatas.edit ?
        await this.$api.missions.editMission(
          this.token, mapData(MISSION_API_MAPPING, data, true, false), this.assignDatas.id
        ) :
        await this.$api.missions.createMission(this.token, mapData(MISSION_API_MAPPING, data, true, false))
      // const missions = res.data.map((item) => this.parseMission(item))
      // this.data = this.assignDatas.edit ? this.data : [...this.data, ...missions]
      this.showAssignReportModal = false
      this.$toast.open({
        message: this.$t('missions.modal.success.title') as string,
        type: 'is-success'
      })
    } catch (error) {
      this.displayErrors(error)
    }
  }

  deleteMission(mission) {
    this.$dialog.confirm({
      title: this.$t('global.info_box.warning') as string,
      message: this.$t('missions.confirm_deletion_modal.sub_title') as string,
      confirmText: this.$t('global.delete') as string,
      cancelText: this.$t('global.button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        try {
          this.tableLoading = true
          const res = await this.$api.missions.deleteMission(this.token, mission.id)
          this.data = this.data.filter((item) => item.id !== mission.id)
          this.$toast.open({
            type: 'is-success',
            message: this.$t('missions.actions.delete.success.title') as string
          })
        } catch (error) {
          this.displayErrors(error)
        } finally {
          this.tableLoading = false
        }
      }
    })
  }
}
